<!-- Column headers (md and up only) -->
<div class="main-panel pebl-grid pebl-grid--scheduled pebl-header">
  <span class="pebl-h-name">Name</span>
  <span class="pebl-h-date">Next send</span>
  <span class="pebl-h-schedule">Schedule</span>
  <span class="pebl-h-recipient">Recipient</span>
  <span class="pebl-h-amount">Amount</span>
  <span class="pebl-h-status">Status</span>
</div>

@if (showSkeleton) {
  <div class="pebl-viewport pebl-skeleton" data-test="pebl-scheduled-skeleton">
    @for (row of skeletonRows; track row) {
      <div class="main-panel pebl-grid pebl-grid--scheduled pebl-grid-row">
        <div class="pebl-cell pebl-c-lead">
          <span class="pebl-skel"></span>
        </div>
        <div class="pebl-cell pebl-c-name">
          <span class="pebl-skel pebl-skel-line"></span>
          <span class="pebl-skel pebl-skel-line pebl-skel-sub"></span>
        </div>
        <span class="pebl-cell pebl-c-date">
          <span class="pebl-skel pebl-skel-line"></span>
        </span>
        <span class="pebl-cell pebl-c-schedule">
          <span class="pebl-skel pebl-skel-line"></span>
        </span>
        <span class="pebl-cell pebl-c-recipient">
          <span class="pebl-skel pebl-skel-line"></span>
        </span>
        <span class="pebl-cell pebl-c-amount">
          <span class="pebl-skel pebl-skel-line"></span>
        </span>
        <div class="pebl-cell pebl-c-status">
          <span class="pebl-skel pebl-skel-status"></span>
        </div>
      </div>
      <mat-divider></mat-divider>
    }
  </div>
} @else {
<!-- main-panel: the viewport paints the same background as its rows. On a hard
     scroll the compositor can reveal a strip before the CDK has rendered rows
     for it, and without this the darker bg-panel behind the list shows through
     as a grey flicker. -->
<cdk-virtual-scroll-viewport
  [itemSize]="rowSize"
  [minBufferPx]="minBufferPx"
  [maxBufferPx]="maxBufferPx"
  class="pebl-viewport main-panel"
>
  <div *cdkVirtualFor="let schedule of schedules; let i = index">
    <div
      class="interactive main-panel pebl-grid pebl-grid--scheduled pebl-grid-row"
      (click)="OpenDetails(schedule)"
      (keydown.enter)="OpenDetails(schedule)"
      tabindex="0"
      role="button"
      data-test="tx-pebl-scheduled-row"
    >
      <!-- Schedule type -->
      <div class="pebl-cell pebl-c-lead">
        <mat-icon
          class="outline"
          [matTooltip]="rowTypeTooltip(schedule)"
          matTooltipPosition="right"
          >{{ rowTypeIcon(schedule) }}</mat-icon
        >
      </div>

      <!-- Name (with the next send date stacked under it on mobile) -->
      <div class="pebl-cell pebl-c-name">
        <span class="pebl-name-text" [matTooltip]="schedule.name || '-'">{{
          schedule.name || '-'
        }}</span>
        <span class="pebl-name-sub">{{
          (rowDate(schedule) | date: 'dd/MM/yy HH:mm') || '-'
        }}</span>
      </div>

      <!-- Next send (own column from md up) -->
      <div class="pebl-cell pebl-c-date">
        @if (rowDate(schedule); as sendDate) {
          <span class="pebl-date-day">{{ sendDate | date: 'd MMM y' }}</span>
          <span class="pebl-date-time">At {{ sendDate | date: 'h:mm a' }}</span>
        } @else {
          <span class="pebl-date-day">-</span>
        }
      </div>

      <!-- Recurrence (md and up) -->
      <span class="pebl-cell pebl-c-schedule">
        @if (schedule.type === 'Recurring') {
          {{ schedule.frequency | titlecase }} ({{ rowOccurrences(schedule) }})
        } @else {
          Once
        }
      </span>

      <!-- Recipient (xl and up) -->
      <span class="pebl-cell pebl-c-recipient" [matTooltip]="rowRecipient(schedule)">{{
        rowRecipient(schedule)
      }}</span>

      <span class="pebl-cell pebl-c-amount">{{
        schedule.amount / 100 | currency: currencyAlphaCode(schedule)
      }}</span>

      <!-- Status: a labelled pill from md up, an icon on mobile -->
      <div class="pebl-cell pebl-c-status">
        <div class="pebl-status-circle {{ rowStatusPillClass(schedule) }}">
          <mat-icon class="m-0 outline">{{ rowStatusPillIcon(schedule) }}</mat-icon>
        </div>
        <div class="pebl-status-pill {{ rowStatusPillClass(schedule) }}">
          <span class="d-block text-center">{{ schedule.status }}</span>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>

  <div>
    @if (loading) {
      <div class="pebl-row__loading p-2 w-100" style="z-index: 1000">
        <odin-loading-spinner
          class="mt-2"
          [active]="true"
          [diameter]="40"
          [colour]="'primary'"
        ></odin-loading-spinner>
        <p class="m-0 text-center w-100">Loading...</p>
      </div>
    }
    @if (!loading && !moreContent && schedules !== undefined && schedules.length > 0) {
      <div class="odin-list-end" data-test="pebl-schedules-list-end">
        <mat-icon class="outline">check_circle</mat-icon>
        <span>End of schedules</span>
      </div>
    }
    @if (!loading && fetched && schedules !== undefined && schedules.length === 0) {
      <div class="odin-empty-state" data-test="pebl-schedules-empty">
        <div class="odin-empty-state-icon">
          <mat-icon class="outline">event_busy</mat-icon>
        </div>
        <p class="odin-empty-state-title">No scheduled links found</p>
        <p class="odin-empty-state-text">
          There are no scheduled payment links matching your current filters.
        </p>
      </div>
    }
  </div>
</cdk-virtual-scroll-viewport>
}
